"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PubSubService = void 0;
var PubSubService = /** @class */ (function () {
    function PubSubService() {
        this.handlers = {};
    }
    PubSubService.prototype._generateSubscriptionId = function (_step) {
        var subscriptionId = "".concat(new Date().getTime(), "_").concat(Math.round(Math.random() * 1000000));
        if (typeof this.handlers[subscriptionId] !== 'undefined') {
            var step = _step || 0;
            if (step > 500) {
                throw new Error('Max stack for creating subscription Id');
            }
            subscriptionId = this._generateSubscriptionId(step + 1);
        }
        return subscriptionId;
    };
    PubSubService.prototype._setLastValue = function (value) {
        this.lastValue = value;
    };
    PubSubService.prototype.getLastValue = function () {
        return this.lastValue;
    };
    PubSubService.prototype.publish = function (data) {
        this._setLastValue(data);
        for (var subscriptionId in this.handlers) {
            if (typeof this.handlers[subscriptionId] === 'function') {
                this.handlers[subscriptionId](data);
            }
        }
    };
    PubSubService.prototype.subscribe = function (handler) {
        var subscriptionId = this._generateSubscriptionId();
        this.handlers[subscriptionId] = handler;
        return subscriptionId;
    };
    PubSubService.prototype.revoke = function (subscriptionId) {
        delete this.handlers[subscriptionId];
    };
    return PubSubService;
}());
exports.PubSubService = PubSubService;
